import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CoreModule as VendastaCoreModule } from '@galaxy/core';
import { PartnerServiceInterfaceToken } from '@galaxy/partner';
import { AccountsService } from '@vendasta/accounts/legacy';
import { AjaxService } from './ajax.service';
import { EmailUsagesService } from './email-usages.service';
import { PaidVersionGuard } from './paid-version-guard';
import { PartnerService } from './partner.service';
import { ProEditionGuard } from './pro-edition-guard.service';
import { ProApiService } from './pro.api.service';
import { ProductService } from './product.service';
import { ReviewGenSettingsService } from './review-gen-settings.service';
import { SmsUsagesService } from './sms-usages.service';
import { TemplateListingService } from './template-listing.service';
import { WhiteLabelService } from './white-label.service';
import { SmsConfigurationGuard } from './sms-configuration-guard';

@NgModule({
  imports: [CommonModule, RouterModule, VendastaCoreModule],
  providers: [
    PaidVersionGuard,
    ProEditionGuard,
    AjaxService,
    SmsUsagesService,
    TemplateListingService,
    ReviewGenSettingsService,
    EmailUsagesService,
    ProApiService,
    AccountsService,
    ProductService,
    PartnerService,
    { provide: PartnerServiceInterfaceToken, useExisting: PartnerService },
    WhiteLabelService,
    SmsConfigurationGuard,
  ],
})
export class CoreModule {}
